import type { ReactNode } from "react";

/** Compatibility shell for galleries; closing content stays in document order. */
export function CcSiteFooterClosingBandProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

/** Stable SSR and hydrated geometry: never reparent a large band into the footer. */
export function CcSiteFooterClosingBandRegister({ children }: { children: ReactNode }) {
  return <div className="cc-closing-inline cc-footer--attached cc-footer--with-closing-band">{children}</div>;
}
